/**
 * @desc 详情
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.outPlanMaster.getDetail.Params, options?: any) {
  return updateResponse(
    http(URL + `/outPlanMaster/detail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
